import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "group" }
const _hoisted_2 = { class: "cursor-pointer flex items-center gap-1.5 text-primary-900 group-hover:text-primary-300" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-col items-center gap-5 px-10 py-10 text-center text-base-500" }
const _hoisted_5 = { class: "text-lg leading-lg font-bold" }
const _hoisted_6 = { class: "p-4" }

import Popover from '../base/Popover.vue';
import IconWarning from '../icons/IconWarning.vue';
import IconArrowDown from '../icons/IconArrowDown.vue';
import Button from '../base/Button.vue';
import Checkboxes from '../form/Checkboxes.vue';
import { inject, ref, watchEffect } from 'vue';
import { useGettext } from 'vue3-gettext';
import { AppConfigType, OptionType } from '~src/admin/types';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'Keywords',
  emits: ["updateSelectedKeywords"],
  setup(__props, { expose: __expose, emit: __emit }) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Emits
const emit = __emit;

// Get keywords from settings
const keywords = ref(config.wordpress.keywords);

// Control keywords
const selectedKeywords = ref<string[]>([]);

// Transform keywords to options
const options: OptionType[] = keywords.value.map((keyword) => {
    return {
        label: keyword,
        value: keyword,
    };
});

// Remove a specific keyword
const removeKeyword = (label: string) => {
    selectedKeywords.value = selectedKeywords.value.filter((keyword) => keyword !== label);
};

__expose({
    removeKeyword,
});

// Whenever selectedKeywords changes update the parent component
watchEffect(() => {
    emit('updateSelectedKeywords', selectedKeywords.value);
});

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Popover, {
      width: "476px",
      disabled: !_unref(isAccountFree) && keywords.value.length === 0
    }, _createSlots({
      trigger: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref($gettext)('Key words')) + " ", 1),
            (selectedKeywords.value.length !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(`(${selectedKeywords.value.length})`), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(IconArrowDown, { class: "transition-transform group-hover:rotate-180" })
        ])
      ]),
      _: 2
    }, [
      (_unref(isAccountFree))
        ? {
            name: "body",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(IconWarning),
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref($gettext)('Upgrade needed')), 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_unref($gettext)('Key words are available only on a paid plan.')) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref($gettext)('Upgrade account to use this feature.')), 1)
                ]),
                _createVNode(Button, {
                  text: _unref($gettext)('Upgrade to paid plan'),
                  size: "large"
                }, null, 8, ["text"])
              ])
            ]),
            key: "0"
          }
        : {
            name: "body",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(Checkboxes, {
                  class: "flex items-start justify-start gap-x-5 gap-y-2",
                  options: _unref(options),
                  name: "keywords",
                  size: "small",
                  selection: "multiple",
                  modelValue: selectedKeywords.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeywords).value = $event))
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            key: "1"
          }
    ]), 1032, ["disabled"])
  ]))
}
}

})